import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=7b6eaad7&scoped=true&"
import script from "./BaseHeading.vue?vue&type=script&lang=js&"
export * from "./BaseHeading.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeading.vue?vue&type=style&index=0&id=7b6eaad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6eaad7",
  null
  
)

export default component.exports